import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const LineIcon = React.memo(function LineIcon(props: TLineIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Line" {...props}>
            <rect width="18" height="1.5" x="2" y="10.25" rx=".5" />
        </IconBase>
    );
});

export default LineIcon;

// #region Types

export type TLineIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <LineIcon /> : { ...IconBaseExample, render: LineIcon };

// #endregion
